import { render, staticRenderFns } from "./WeightTicketNew.vue?vue&type=template&id=5fb302b2"
import script from "./WeightTicketNew.vue?vue&type=script&lang=js"
export * from "./WeightTicketNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports